import { makePutRequest } from 'owa-ows-gateway';
import { ActivityStateFlags } from './ActivityFeedStorageItem';

const UPDATE_ACTIVITY_FEED_STATE_URL: string = 'ows/v2.0/ActivityFeed/UpdateActivityFeedState';

export async function updateActivityFeedState(
    items: string[],
    activityStatesToSet: ActivityStateFlags = ActivityStateFlags.None,
    activityStatesToReset: ActivityStateFlags = ActivityStateFlags.None
): Promise<void> {
    if (
        items.length === 0 ||
        (activityStatesToSet === ActivityStateFlags.None &&
            activityStatesToReset === ActivityStateFlags.None)
    ) {
        return;
    }

    makePutRequest(UPDATE_ACTIVITY_FEED_STATE_URL, {
        itemIds: items,
        activityStatesToSet: activityStatesToSet,
        activityStatesToReset: activityStatesToReset,
    });
}
